// Libs
import classNames from 'classnames/bind';
import { Box, IconButton, Stack, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Badge from '@mui/material/Badge';
// Components, Layouts, Pages
import { BaseTabList, UnderDevelopment } from '~/components/common';
import { CommunicationPhoneCallsTab, CommunicationTextMessagesTab } from '~/pages/common';
// Others
import { IBaseTabItem } from '~/utils/interface/common';
import { CommunicationTabEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './Communication.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const Communication = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/communication', 'common/base']);
  const { hash } = useLocation();
  const navigate = useNavigate();

  const getMenuItems = useCallback(() => {
    const items: Array<IBaseTabItem> = [
      { label: CommunicationTabEnum.PHONE_CALLS, component: <CommunicationPhoneCallsTab /> },
    ];

    items.push({ label: CommunicationTabEnum.TEXT_MESSAGES, component: <CommunicationTextMessagesTab /> });

    setTabItems(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isShowUnderDevelopment, setIsShowUnderDevelopment] = useState<boolean>(false);

  const [tabKey, setTabKey] = useState<string>(CommunicationTabEnum.PHONE_CALLS);
  const [tabItems, setTabItems] = useState<IBaseTabItem[]>([]);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (hash) setTabKey(hash.slice(1));
  }, [hash]);

  useEffect(() => {
    getMenuItems();
  }, [getMenuItems]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleShowUnderDevelopment = () => {
    setIsShowUnderDevelopment(!isShowUnderDevelopment);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(`#${newValue}`);
  };

  const renderTabContent = () => {
    const item = tabItems.find((tabItem: IBaseTabItem) => {
      return tabKey === tabItem.label;
    });

    return item?.component;
  };
  //#endregion Handle Function

  return (
    <Stack id='communicationPage' className={cx('container')}>
      <Box component={'div'} className={cx('body')}>
        <BaseTabList
          value={tabKey}
          onChange={handleTabChange}
          childrenAction={
            <Stack direction={'row'} alignItems={'center'} gap={'16px'} flexWrap={'wrap'}>
              <IconButton className={cx('buttonIcon')} onClick={handleShowUnderDevelopment}>
                <img src={icons.commonIconCallPhone} alt={'common_alt_img'} />
              </IconButton>

              <IconButton className={cx('buttonIcon')} onClick={handleShowUnderDevelopment}>
                <img src={icons.commonIconNotification} alt={'common_alt_img'} />
                <Badge
                  badgeContent={3}
                  overlap='circular'
                  className={cx('viewCartBadge')}
                  slotProps={{
                    badge: {
                      className: 'bg-bg-notification text-white text-10-400-15',
                    },
                  }}
                />
              </IconButton>
            </Stack>
          }
        >
          {tabItems.map((item, index) => (
            <Tab
              value={item.label}
              key={index}
              label={t(`tab_label_${item.label}`)}
              className={cx('tabItem', { active: tabKey === item.label })}
            />
          ))}
        </BaseTabList>

        <Box component={'div'} className={cx('tabContent')}>
          {renderTabContent()}
        </Box>
      </Box>

      {isShowUnderDevelopment && <UnderDevelopment onClose={handleShowUnderDevelopment} />}
    </Stack>
  );
};

export default Communication;
